import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { ProgressBar, Badge, Table } from "react-bootstrap";
import { Col, Row, Tab, Nav } from 'react-bootstrap';
import { Link,useNavigate } from "react-router-dom";

const ProfitPage = () => {
    // Define the state to store the profit data
    const [profits, setProfits] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [profits1, setProfits1] = useState(null);
     const [month, setMonth] = useState('');
    const [year, setYear] = useState('');
    const navigate = useNavigate();

  //================================================================
  const userPermissionsJSON = localStorage.getItem('USER_PERMISSIONS2');
  const userPermissions = JSON.parse(userPermissionsJSON);
  function getActionsForPage(pageName) {
    const pagePermissions = userPermissions.find(permission => permission.resource === pageName);
 console.log('actionsForPage',pagePermissions); 
   if (pagePermissions) {
       return pagePermissions.action;
   } else {
  navigate('/dashboard_1')
      return [];
   }
 }
 const pageName = 'First';
 const actionsForPage = getActionsForPage(pageName);

 //=============================================================================================
    // Function to fetch profit data
    const fetchProfits = async () => {
      setLoading(true);
      setError('');
      try {
        // Build query parameters
        const params = {};
        if (month) params.month = month;
        if (year) params.year = year;

        const response = await axios.get('https://subk.education.com.ly/back/api/profitsall', { params });
        setProfits(response.data.data);
      } catch (err) {
        setError(err.response?.data?.message || 'Error fetching profit data');
      } finally {
        setLoading(false);
      }
    };
    const handleClearSearch = () => {
        setMonth(''); // Reset start month
    setYear('');
      };
    // Handle form submission
    const handleSearch = (e) => {
      e.preventDefault();
      fetchProfits();
    };
    // Fetch the profits data from the API
    useEffect(() => {
        axios
            .get('https://subk.education.com.ly/back/api/profits')  // Adjust the URL if necessary
            .then((response) => {
                setProfits1(response.data.data);  // Save the profit data in state
                setLoading(false);  // Set loading to false after data is fetched
            })
            .catch((err) => {
                setError('Failed to load profit data');  // Handle any error
                setLoading(false);  // Set loading to false if there's an error
            });
    }, []);  // Empty dependency array means this will run once when the component mounts

    if (loading) {
        return <div>Loading...</div>;
    }

    if (error) {
        return <div>{error}</div>;
    }
    const arabicMonths = [
        'يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو',
        'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر'
    ];
    return (
        <div className='container-fluid'>
        <Row>
            <Col lg="12">
                <div className="card px-4">
                    <div className="card-body p-0">
                        <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">

                            <div className="tbl-caption">
                                <h4 className="heading ms-3">ارباح الشركة</h4>
                            </div>
                          
    <div className="container-fluid">
        <div className="table-responsive">
             
        <div className="row mb-3" style={{ display: 'flex' }}>
    <div className="col-md-4" style={{ display: 'flex' }}>
        <label style={{ fontSize: '15px', fontWeight: 'bold' }}>
            <i className="fa-solid fa-dollar-sign" style={{ marginLeft: '5px', marginRight: '8px' }}></i>
            إجمالي الإيرادات:
        </label>
        <div style={{ color: 'blue', marginRight: '8px', marginTop: '2px' }}>
            <strong>{profits1.total_revenue} د </strong>
        </div>
    </div>
    <div className="col-md-4" style={{ display: 'flex' }}>
        <label style={{ fontSize: '15px', fontWeight: 'bold' }}>
            <i className="fa-solid fa-boxes" style={{ marginLeft: '5px', marginRight: '8px' }}></i>
            إجمالي تكلفة البضائع المباعة:
        </label>
        <div style={{ color: 'red', marginRight: '8px', marginTop: '2px' }}>
            <strong>{profits1.total_cogs} د </strong>
        </div>
    </div>
    <div className="col-md-4" style={{ display: 'flex' }}>
        <label style={{ fontSize: '15px', fontWeight: 'bold' }}>
            <i className="fa-solid fa-chart-line" style={{ marginLeft: '5px', marginRight: '8px' }}></i>
            إجمالي الربح:
        </label>
        <div style={{ color: 'green', marginRight: '8px', marginTop: '2px' }}>
            <strong>{profits1.gross_profit} د </strong>
        </div>
    </div>
</div>

<div className="row mb-3" style={{ display: 'flex' }}>
    <div className="col-md-4" style={{ display: 'flex' }}>
        <label style={{ fontSize: '15px', fontWeight: 'bold' }}>
            <i className="fa-solid fa-cogs" style={{ marginLeft: '5px', marginRight: '8px' }}></i>
            المصروفات التشغيلية:
        </label>
        <div style={{ color: 'red', marginRight: '8px', marginTop: '2px' }}>
            <strong>{profits1.operating_expenses} د </strong>
        </div>
    </div>
    <div className="col-md-4" style={{ display: 'flex' }}>
        <label style={{ fontSize: '15px', fontWeight: 'bold' }}>
            <i className="fa-solid fa-chart-bar" style={{ marginLeft: '5px', marginRight: '8px' }}></i>
            إجمالي المصروفات:
        </label>
        <div style={{ color: 'green', marginRight: '8px', marginTop: '2px' }}>
            <strong>{profits1.operating_profit} د </strong>
        </div>
    </div>
    <div className="col-md-4" style={{ display: 'flex' }}>
        <label style={{ fontSize: '15px', fontWeight: 'bold' }}>
            <i className="fa-solid fa-wallet" style={{ marginLeft: '5px', marginRight: '8px' }}></i>
            صافي الربح:
        </label>
        <div style={{ color: 'blue', marginRight: '8px', marginTop: '2px' }}>
            <strong>{profits1.net_profit} د </strong>
        </div>
    </div>
</div>


            {/* Profit Metrics Form */}
            <div className="row mb-4">
                <div className="col-md-12">
                    <form onSubmit={handleSearch} style={{ display: 'flex', gap: '15px' }}>
                    <div className="form-group" style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
    <label htmlFor="month" style={{ marginLeft: '10px', whiteSpace: 'nowrap' }}>الشهر:</label>
    <select
        id="month"
        className="form-control"
        style={{ flex: '1' }}
        value={month}
        onChange={(e) => setMonth(e.target.value)}
    >
        <option value="">الكل</option>
        {arabicMonths.map((monthName, index) => (
            <option key={index + 1} value={index + 1}>
                {monthName}
            </option>
        ))}
    </select>
</div>
<div className="form-group" style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
    <label htmlFor="year" style={{ marginLeft: '10px', whiteSpace: 'nowrap' }}>السنة:</label>
    <input
        type="number"
        id="year"
        className="form-control"
        style={{ flex: '1' }}
        placeholder="ادخل السنة"
        value={year}
        onChange={(e) => setYear(e.target.value)}
    />
</div>

                        <div className="col-md-3">
          <button className="btn btn-primary btn-sm me-1"type='submit'>ابحت</button>
        
           <button className="btn btn-secondary btn-sm me-1" onClick={handleClearSearch}> الغاء</button>
        </div>                    </form>
                </div>
            </div>

            {/* Results */}
            {loading && <p>Loading...</p>}
            {error && <p className="text-danger">{error}</p>}

            {profits && (
                <Table responsive striped bordered className="verticle-middle">
                     <thead style={{ position: "sticky", top: 0,  zIndex: 1 }}>                      

                        <tr>
                        <th>  إجمالي الإيرادات</th>
                        <th>إجمالي تكلفة البضائع المباعة</th>
                        <th>إجمالي الربح</th>
                        <th>المصروفات التشغيلية</th>
                        <th>الربح التشغيلي</th>
                        <th>إجمالي المصروفات</th>
                        <th>صافي الربح</th>
                             
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>  {profits.total_revenue}  د    </td>
                            <td>  {profits.total_cogs} د   </td>
                            <td>  {profits.gross_profit} د  </td>
                            <td>  {profits.operating_expenses} د </td>
                            <td>  {profits.operating_profit} د </td>
                            <td>  {profits.total_expenses} د </td>
                            <td>  {profits.net_profit} د </td>
                        </tr>
                    </tbody>
                </Table>
            )}
        </div>
    </div>


                     </div>       
              </div>
        </div>
        </Col>
        </Row>
        </div>
    );
}    

export default ProfitPage;
